import { mobileBreakPoint } from '~/styles/break-points';
import { windowAvailable } from '~/utils/client-detection';

export function isMobile() {
	return 'ontouchstart' in window;
}

export function isMobileView() {
	return windowAvailable() ? window?.innerWidth < mobileBreakPoint : undefined;
}

export function isPhone() {
	return /Android|webOS|iPhone|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}

export function isIPad() {
	return navigator.maxTouchPoints && navigator.maxTouchPoints > 2 && /Macintosh/.test(navigator.userAgent);
}
